import Axios from 'axios';
import { UserInvitePayload, RolesPayload, AlarmSettingsPayload, GetAlarmSettingsPayload, UserStatsResponse } from 'model/api';

export const getUserById = async (userId: string, expand: string[] = []): Promise<any> => {
  const parameters = (expand.length > 0) ? `?expand=${expand.join(',')}` : '';
  const response = await Axios.get(`/users/${userId}${parameters}`);
  return response.data;
}

export const getAccountById = async (accountId: string, expand: string[] = []): Promise<any> => {
  const parameters = (expand.length > 0) ? `?expand=${expand.join(',')}` : '';
  const response = await Axios.get(`/accounts/${accountId}${parameters}`);
  return response.data;
}

export const saveUser = async (userId: string, user: any): Promise<any> => {
  const response = await Axios.post(`/users/${userId}`, user);
  return response.data;
}

export const inviteUser = async (invite: UserInvitePayload): Promise<any> => {
  const response = await Axios.post('/accounts/invite/', invite);
  return response.data;
}

export const resendUserInvite = async (email: string, accountId: string): Promise<any> => {
  const response = await Axios.post('/accounts/invite/resend', { email });
  return response.data;
}

export const revokeUserInvite = async (email: string, accountId: string): Promise<any> => {
  const response = await Axios.post('/accounts/invite/revoke', { email, accountId });
  return response.data;
}

export const removeUser = async (userId: string): Promise<any> => {
  const response = await Axios.delete(`/users/${userId}`);
  return response.data;
}

export const editAccountRoles = async (accountId: string, userId: string, payload: RolesPayload): Promise<any> => {
  const response = await Axios.post(`/accounts/${accountId}/user-roles/${userId}`, payload);
  return response.data;
}

export const saveUserCredentials = async (userId: string, oldPassword: string, newPassword: string): Promise<any> => {
  const response = await Axios.post(`/users/${userId}/password`, {
    oldPassword,
    newPassword
  });
  return response.data;
}

export const saveAlarmSettings = async (userId: string, alarmSettings: AlarmSettingsPayload): Promise<any> => {
  const response = await Axios.post(`/users/${userId}/alarmSettings`, alarmSettings);
  return response.data;
}

export const getAlarmSettings = async (userId: string, payload: GetAlarmSettingsPayload): Promise<any> => {
  const response = await Axios.post(`/users/${userId}/alarmSettings/_get`, payload);
  return response.data;
}

export const getUserStats = async (userId: string): Promise<UserStatsResponse> => {
  const response = await Axios.get(`/users/${userId}/stats`);
  return response.data;
}
